module.exports = __webpack_public_path__ + "img/header-diamondJewelrySets@2x.0adfe0c.jpg";